import { createSlice } from "@reduxjs/toolkit";
import { UserMsgTemplateDTO } from "../../models/MsgTemplate.model";
import {
  getAllUserMsgTemplates,
  createUserMsgTemplate,
  deleteUserMsgTemplate,
  getMsgTemplateTags,
} from "../thunks/msgTemplateThunks";

interface MsgTemplateState {
  templates: UserMsgTemplateDTO[];
  loading: boolean;
  error: string | null;
  saveLoading: boolean;
  deleteLoading: boolean;
  resolving: boolean;
  resolvedBody: string | null;
}

const initialState: MsgTemplateState = {
  templates: [],
  loading: false,
  error: null,
  saveLoading: false,
  deleteLoading: false,
  resolving: false,
  resolvedBody: null,
};

const msgTemplateSlice = createSlice({
  name: "msgTemplate",
  initialState,
  reducers: {
    clearMsgTemplateError(state) {
      state.error = null;
    },
    clearMsgTemplates(state) {
      state.templates = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- getAllUserMsgTemplates --------------------
      .addCase(getAllUserMsgTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUserMsgTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload.templates || [];
      })
      .addCase(getAllUserMsgTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה בשליפת תבניות";
      })

      // -------------------- createUserMsgTemplate --------------------
      .addCase(createUserMsgTemplate.pending, (state) => {
        state.saveLoading = true;
        state.error = null;
      })
      .addCase(createUserMsgTemplate.fulfilled, (state) => {
        state.saveLoading = false;
      })
      .addCase(createUserMsgTemplate.rejected, (state, action) => {
        state.saveLoading = false;
        state.error = action.payload || "שגיאה בשמירת תבנית";
      })

      // -------------------- deleteUserMsgTemplate --------------------
      .addCase(deleteUserMsgTemplate.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteUserMsgTemplate.fulfilled, (state) => {
        state.deleteLoading = false;
      })
      .addCase(deleteUserMsgTemplate.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload || "שגיאה במחיקת תבנית";
      })

      // -------------------- getMsgTemplateTags --------------------
      .addCase(getMsgTemplateTags.pending, (state) => {
        state.resolving = true;
        state.resolvedBody = null;
        state.error = null;
      })
      .addCase(getMsgTemplateTags.fulfilled, (state, action) => {
        state.resolving = false;
        state.resolvedBody = action.payload.templateBody;
      })
      .addCase(getMsgTemplateTags.rejected, (state, action) => {
        state.resolving = false;
        state.error = action.payload || "שגיאה ברזולוציית תגיות";
      });
  },
});

export const { clearMsgTemplateError, clearMsgTemplates } =
  msgTemplateSlice.actions;
export default msgTemplateSlice.reducer;
